import { WidgetNames } from "constants/widgets";
import { DashboardContext } from "contexts/DashboardContext";
import React, { useContext } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

import { FONTS } from "../constants";

interface FontSelectSettingsInfo {
  title: string;
}

export const FontSelectSettings: WidgetSettingFC<string, FontSelectSettingsInfo> = (props) => {
  const { data, setData, info } = props;
  const { title } = info;

  const { data: globalData, setData: updateGlobalData } = useContext(DashboardContext);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setData(event.target.value);

    const currentDashboardRememberSettings = globalData.dashboardGroups
      .find((group) => group.id === globalData.activeDashboardGroupId)!
      .dashboards.find((d) => d.id === globalData.activeDashboardId)!;

    if (currentDashboardRememberSettings.rememberSettings[WidgetNames.freeText].isOn) {
      const newDashboardData = globalData.dashboardGroups
        .find((group) => group.id === globalData.activeDashboardGroupId)!
        .dashboards.map((dashboard) => {
          if (dashboard.id === globalData.activeDashboardId) {
            return {
              ...dashboard,
              rememberSettings: {
                ...dashboard.rememberSettings,
                [WidgetNames.freeText]: {
                  isOn: true,
                  settings: {
                    ...currentDashboardRememberSettings.rememberSettings[WidgetNames.freeText]
                      .settings,
                    fontFamily: event.target.value,
                  },
                },
              },
            };
          }

          return dashboard;
        });

      const newGroups = [...globalData.dashboardGroups];
      newGroups.find((group) => group.id === globalData.activeDashboardGroupId)!.dashboards =
        newDashboardData;

      updateGlobalData({
        dashboardGroups: newGroups,
      });
    }
  };

  return (
    <OuterContainer>
      <Form.Group>
        <Title>{title}</Title>

        <Form.Control as="select" value={data || FONTS[0]} onChange={handleChange}>
          {FONTS.map((f, index) => (
            <option key={index}>{f}</option>
          ))}
        </Form.Control>
      </Form.Group>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  margin-bottom: 35px;
`;

const Title = styled(Form.Label)`
  color: var(--secondary);
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 12pt;
`;
